<template>
	<div class="partner-list" :class="{'child-expanded' : hasAChildExpanded}">
		<partner-item 
			v-for="(partner, i) in partners"
			:partner=partner
			:key=i
			:id=i
			v-on:toggleState="onToggleState($event)"
		></partner-item>
	</div>
</template>

<script>
import PartnerItem from './PartnerItem'
import moment from 'moment'
import { SIGNOUT } from '@/vuex/mutations'

export default {
	components : { PartnerItem },
	computed : {
		partners() {
			return this.$store.getters.partners;
		}
	},
	mounted() {
		let tokenGivenAt = this.$store.state.tokenGivenAt.clone();
		tokenGivenAt.add(8, "h");
		let now = moment();
		
		if(now.isAfter(tokenGivenAt)) {
			this.$store.commit(SIGNOUT);
			this.$router.push("/login");
		}
	},
	data() {
		return {
			hasAChildExpanded : false
		}
	},
	methods : {
		onToggleState(isExpanded) {
			this.hasAChildExpanded = isExpanded;
		}
	}
}
</script>

<style lang="scss">
.partner-list {
	display : flex;
	flex-wrap : wrap;
	position : relative;

	overflow-y : auto;
	scroll-behavior: smooth;
	justify-content : center;

	max-height : calc(100% - 150px);
	min-height : calc(100% - 150px);

	&.child-expanded {
		justify-content: center;
		> .expanded {
			margin : 15px 0px;
		}
		> :not(.expanded) {
			display : none;
		}
	}
}	
</style>